"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whiteBackgrounds = void 0;
exports.whiteBackgrounds = {
    backgroundColor: "#ffffff",
    backgroundColor2: "#ffffff",
    text: "#000000",
    subduedText: "#00000060",
    focus: "#000000",
    toggleOff: "#00000060",
};
//# sourceMappingURL=whiteBackgrounds.js.map